// 1. i18n must be imported first (side-effect: runs init)
import '@/i18n/i18n'

// 2. Global styles
import '@/index.css'

import React    from 'react'
import ReactDOM from 'react-dom/client'
import App      from './App'
import { ThemeProvider } from '@/context/ThemeContext'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>,
)
